import React from 'react'
import { InfoProdutosWrapper, CardInfoProduto } from '../style'
import { CustomButton } from 'styles/global'
import { HashLink } from 'react-router-hash-link'
import { scrollWithOffset } from 'util/scrollWithOffset'

const InfoProdutos = () => {
  return (
    <InfoProdutosWrapper id="produtos">
      <div className="container container-banner justify-content-center align-items-center">
        <h3 className="title">
          Seu crédito do seu jeito, com total{' '}
          <span className="title-tag-Laranja">
            <br />
            segurança.{' '}
          </span>
        </h3>
        <span className="subtitle">
          Encontre a solução certa e conquiste seus objetivos com tranquilidade.
        </span>
      </div>

      <div className="content-produtos">
        <CardInfoProduto>
          <div className="content-infos">
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_5.png"
              width={35}
            />
            <label>
              Crédito <br /> consignado
            </label>
            <span>
              Ideal para aposentados, pensionistas e servidores públicos.
            </span>
            <ul>
              <li>Até 96 parcelas</li>
              <li>Valores a partir de R$ 1.100,00</li>
              <li>Taxas a partir de 1,85% a.m </li>
            </ul>
          </div>
          <HashLink
            to="/#iniciar-simulacao"
            className="w-auto mx-4 no-styled-link"
            smooth
            scroll={(el) => {
              scrollWithOffset(el, 300)
            }}
          >
            <CustomButton
              className="button-simulation"
              background="var(--verde-riber)"
              onClick={() => {
                //
              }}
            >
              Simular
            </CustomButton>
          </HashLink>
        </CardInfoProduto>
        <CardInfoProduto>
          <div className="content-infos">
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_6.png"
              width={35}
            />
            <label>
              Cartão de crédito <br /> consignado
            </label>
            <span>
              Ideal para aposentados, pensionistas e servidores públicos.
            </span>
            <ul>
              <li>Sem anuidade</li>
              <li>Limite de até 1,6x o benefício</li>
              <li>Taxa de 2,73% a.m</li>
            </ul>
          </div>
          <HashLink
            to="/#iniciar-simulacao"
            className="w-auto mx-4 no-styled-link"
            smooth
            scroll={(el) => {
              scrollWithOffset(el, 300)
            }}
          >
            <CustomButton
              className="button-simulation"
              background="var(--verde-riber)"
              onClick={() => {
                //
              }}
            >
              Simular
            </CustomButton>
          </HashLink>
        </CardInfoProduto>
        <CardInfoProduto>
          <div className="content-infos">
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_7.png"
              width={35}
            />
            <label>
              Antecipação do <br /> FGTS
            </label>
            <span>Ideal para quem trabalha com carteira assinada.</span>
            <ul>
              <li>Dinheiro rápido na conta</li>
              <li>Sem parcelas mensais</li>
              <li>Desconto direto do saldo FGTS</li>
            </ul>
          </div>
          <HashLink
            to="/#iniciar-simulacao"
            className="w-auto mx-4 no-styled-link"
            smooth
            scroll={(el) => {
              scrollWithOffset(el, 300)
            }}
          >
            <CustomButton
              className="button-simulation"
              background="var(--verde-riber)"
              onClick={() => {
                //
              }}
            >
              Simular
            </CustomButton>
          </HashLink>
        </CardInfoProduto>
        <CardInfoProduto>
          <div className="content-infos">
            <img
              src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/home_8.png"
              width={35}
            />
            <label>
              Crédito <br /> pessoal
            </label>
            <span>
              Ideal para aposentados e pensionistas, servidores públicos.
            </span>
            <ul>
              <li>Sem garantia</li>
              <li>Débito em conta</li>
              <li>Liberação ate 24 horas</li>
            </ul>
          </div>
          <HashLink
            to="/#iniciar-simulacao"
            className="w-auto mx-4 no-styled-link"
            smooth
            scroll={(el) => {
              scrollWithOffset(el, 300)
            }}
          >
            <CustomButton
              className="button-simulation"
              background="var(--verde-riber)"
              onClick={() => {
                //
              }}
            >
              Simular
            </CustomButton>
          </HashLink>
        </CardInfoProduto>
      </div>
    </InfoProdutosWrapper>
  )
}

export default InfoProdutos
